document.addEventListener('submit', (event) => {
  const form = event.target.closest('.anirona-protected-form');
  if (!form || !form.checkValidity()) return;

  const button = form.querySelector('[type="submit"]');
  if (!button || button.getAttribute('aria-disabled') === 'true') {
    event.preventDefault();
    return;
  }

  button.setAttribute('aria-disabled', 'true');
  button.disabled = true;
  const pendingLabel = button.dataset.pendingLabel;
  if (pendingLabel) button.textContent = pendingLabel;
});
